import { createAction } from '@ngrx/store'

export namespace AppActions {
  export const disablePaymentButton = createAction('[Dashboard Layout Component] Disable payment button')
  export const enablePaymentButton = createAction('[Dashboard Layout Component] Enable payment button')
  export const hideNotice = createAction('[Flow Layout Component] Hide notice')
  export const showNotice = createAction('[Flow Layout Component] Show notice')
  export const hideCardMenu = createAction('[Dashboard Layout] hideCardMenu')
  export const showCardMenu = createAction('[Dashboard Layout] showCardMenu')
}
